import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../helpers/export'
import CompanyProfileService from './CompanyProfileService'

const screen = SCREEN.COMPANY_PROFILE

export const getCompanyHighlight = createAsyncThunk(
  'companyAnalysis/companyProfile/getCompanyHighlight',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await CompanyProfileService.getCompanyHighlight(params)
      if (response.success) {
        const getValues = () => [
          {
            value: response.data.charterCapital,
            year: params.fiscalYearEnd,
            exchangeRateType: 'lastDayRate',
          },
        ]
        dispatch(calculateDefaultUnit({ screen, getValues }))
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getCompanyInfoDetail = createAsyncThunk(
  'companyAnalysis/companyProfile/getCompanyInfoDetail',
  async (params, { rejectWithValue }) => {
    try {
      const response = await CompanyProfileService.getCompanyInfoDetail(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportCompanyOverview = createAsyncThunk(
  'companyAnalysis/companyProfile/exportCompanyOverview',
  async (params, { rejectWithValue }) => {
    try {
      const response = await CompanyProfileService.exportCompanyOverview(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportIndustry = createAsyncThunk(
  'companyAnalysis/companyProfile/exportIndustry',
  async (params, { rejectWithValue }) => {
    try {
      const response = await CompanyProfileService.exportIndustry(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportBoardOfDirector = createAsyncThunk(
  'companyAnalysis/companyProfile/exportBoardOfDirector',
  async (params, { rejectWithValue }) => {
    try {
      const response = await CompanyProfileService.exportBoardOfDirector(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportBoardOfManagement = createAsyncThunk(
  'companyAnalysis/companyProfile/exportBoardOfManagement',
  async (params, { rejectWithValue }) => {
    try {
      const response = await CompanyProfileService.exportBoardOfManagement(
        params,
      )
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)
